import { createClient } from '@supabase/supabase-js'

// Supabase configuration
const SUPABASE_URL = 'https://lgmeeuozhlbwtsbarroy.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxnbWVldW96aGxid3RzYmFycm95Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQyNTI5OTcsImV4cCI6MjA2OTgyODk5N30.xeiPgXgzL2uRtd4lkJiHL8weHrMIsB1mRsjnjqDL1ig'

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})